import { gql } from '@apollo/client'

export const GET_FACT_SOURCES = gql`
  query($countryCode: String!) {
    getFactSources {
      id
      origin
      sources {
        category
        chart
        configuration
        country_code
        cycle
        gfk_id
        import_date_offset
        import_limit
        release_info
        visible
      }
    }
    getLatestChartsByCountryCode(countryCode: $countryCode ) {
        chart
        date
        configuration
    }
  }
`
